import classnames from '@helpers/misc/classnames'
import Link from 'next/link'

type LogoLinkProps = {
  url: string
  title: string
  isScrolled: boolean
}

function LogoLink(props: LogoLinkProps) {
  const {url, title, isScrolled} = props
  if (!url) return null

  return (
    <div
      className={classnames(
        'relative flex justify-start max-w-[30dvw] h-12 transition-all ease-in-out duration-100',
        isScrolled ? 'md:h-14' : 'md:h-16',
      )}
    >
      <Link href="/">
        <img
          src={url}
          alt={title || 'logo'}
          title={title || 'logo'}
          className={'h-full object-contain'}
        />
      </Link>
    </div>
  )
}

export default LogoLink
